import { render, staticRenderFns } from "./IconSmile.vue?vue&type=template&id=10f00765&"
import script from "./IconSmile.vue?vue&type=script&lang=js&"
export * from "./IconSmile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports